module.exports = __webpack_public_path__ + "static/media/linkedinwhite.6f79fabe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social/linkedinwhite.svg
// module id = 134
// module chunks = 0